import { useState } from "react";

const RoomCodeDisplay = ({ code }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard?.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="room-code-box">
      <div className="room-code-label">Share this code with your friend</div>
      <div className="room-code-value">{code}</div>
      <button className="copy-btn" onClick={handleCopy}>
        {copied ? "✓ Copied!" : "📋 Copy Code"}
      </button>
    </div>
  );
};

export default RoomCodeDisplay;